import process from "process"
import React from "react"
import { Box } from "@chakra-ui/react"

export default function Debug() {
  return (
    <Box>
      <Box>
        <h1>Debug</h1>
      </Box>
      <Box>BLINDINSIGHT_PROXY_URL: {process.env.BLINDINSIGHT_PROXY_URL}</Box>
    </Box>
  )
}
